<template>
    <div v-if="tags" class="certificate__container">
        <div
            ref="certificatePrint"
            class="certificate__container-side"
            :style="{
                '--certificate-width': `${certificateSizes.width}px`,
                '--certificate-height': `${certificateSizes.height}px`,
            }"
        >
            <vue-draggable-resizable
                class="certificate__container-side--tag"
                v-for="tag in convertedTags"
                :key="tag.id"
                :x="tag.x"
                :y="tag.y"
                :w="tag.w"
                :h="tag.h"
                :disable-user-select="false"
                :draggable="false"
                :resizable="false"
                parent
            >
                <component
                    :key="`tag_content-${tag.id}`"
                    :is="contentType(tag.type)"
                    :data="tag"
                />
            </vue-draggable-resizable>
            <img
                v-if="backgroundImage"
                ref="background"
                :src="backgroundImage"
                class="certificate__container-side--image"
            />
        </div>
    </div>
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable-vue3';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';

import CertificateInputText from './CertificateTags/CertificateInputText';
import CertificateInputImage from './CertificateTags/CertificateInputImage';
import CertificateInputQrcode from './CertificateTags/CertificateInputQrcode';
import CertificateInputSignature from './CertificateTags/CertificateInputSignature';

export default {
    name: 'CertificateTagDraggable',
    components: {
        VueDraggableResizable,
        CertificateInputText,
        CertificateInputImage,
        CertificateInputQrcode,
        CertificateInputSignature,
    },
    props: {
        side: {
            type: String,
            required: true,
            description: 'lado do certificado, frente (front) ou verso (back)',
        },
        certificate: {
            type: Object,
            required: true,
            description: 'Objeto do certificado contento as imagens e tags de cada lado',
        },
    },
    data() {
        return {
            output: false,
            certificateSizes: {
                width: 1121,
                height: 790.99,
            },
        };
    },
    computed: {
        tags() {
            return this.certificate[this.side] || [];
        },
        convertedTags() {
            return this.tags.map(tag => ({
                ...tag,
                x: this.convertDimension(tag.x, 'width'),
                y: this.convertDimension(tag.y, 'height'),
                // tags legadas salvas com 'w: auto' (pré-migração Vue 3)
                // colapsam o container e o texto sai na vertical, estourando
                // o PDF em duas páginas (suporte/geral#794)
                w: this.convertDimension(isNaN(parseFloat(tag.w)) ? 500 : tag.w, 'width'),
                h: this.convertDimension(tag.h, 'height'),
            }));
        },
        backgroundImage() {
            if (this.certificate.files && this.certificate.files[this.side]) {
                return this.getBackground(this.certificate.files[this.side]);
            }
            return false;
        },
    },
    methods: {
        convertDimension(value, type) {
            const baseDimensions = { height: 600, width: 800 };
            const validType = Object.keys(baseDimensions).includes(type);
            if (!isNaN(value) && validType) {
                const base = baseDimensions[type];
                const dimension = this.certificateSizes[type] * value;
                return Math.round(dimension / base);
            }
            return value;
        },
        getBackground({ host, original_file: file, urls }) {
            if (urls && urls.lg) {
                return urls.lg;
            }
            if (host) {
                return `/storage/${host}/lg/${file}`;
            }
            return '/img/certificate_bg.png';
        },
        contentType(type) {
            const types = {
                logo: 'CertificateInputImage',
                qrcode: 'CertificateInputQrcode',
                signature: 'CertificateInputSignature',
            };
            const content = types[type];
            return content || 'CertificateInputText';
        },
    },
};
</script>
<style>
.ql-size-small {
    font-size: 0.75em;
}
.ql-size-large {
    font-size: 1.5em;
}
.ql-size-huge {
    font-size: 2.5em;
}
</style>
<style scoped>
.certificate__container-side {
    height: var(--certificate-height);
    width: var(--certificate-width);
}
.certificate__container-side--tag {
    z-index: 1 !important;
    border: none;
    align-items: center;
}
.certificate__container
    .certificate__container-side
    img.certificate__container-side--image {
    height: var(--certificate-height);
    width: var(--certificate-width);
}
</style>

<style>
#certificate__wrapper {
    position: relative;
    padding: 0 !important;
    margin: 0 !important;
    border: 1px solid white;
}
@media print {
    @page {
        size: A4 landscape;
        margin: 0;
        padding: 0;
    }
}
#app > div:nth-child(2) > div.nch--navbar__fixed > div:nth-child(3) > div > div.col-12 {
    margin-top: 30px !important;
}
</style>

